import apiClient from './client'
import type { Group, CreateGroupRequest, UpdateGroupRequest } from '@/types/api'

export const groupsApi = {
  // POST /api/v1/assistants/{assistantId}/groups - создать группу
  create: async (assistantId: string, data: CreateGroupRequest): Promise<Group> => {
    const response = await apiClient.post<Group>(`/assistants/${assistantId}/groups`, data)
    return response.data
  },

  // GET /api/v1/groups/{id} - получить группу
  getById: async (id: string): Promise<Group> => {
    const response = await apiClient.get<Group>(`/groups/${id}`)
    return response.data
  },

  // GET /api/v1/assistants/{assistantId}/groups - список групп ассистента
  getByAssistantId: async (assistantId: string): Promise<Group[]> => {
    const response = await apiClient.get<Group[]>(`/assistants/${assistantId}/groups`)
    return response.data
  },

  // PUT /api/v1/groups/{id} - обновить группу
  update: async (id: string, data: UpdateGroupRequest): Promise<Group> => {
    const response = await apiClient.put<Group>(`/groups/${id}`, data)
    return response.data
  },

  // GET /api/v1/assistants/{assistantId}/groups/search - поиск групп
  search: async (assistantId: string, query: string): Promise<Group[]> => {
    const response = await apiClient.get<Group[]>(
      `/assistants/${assistantId}/groups/search`,
      { params: { q: query } }
    )
    return response.data
  },

  // POST /api/v1/groups/{id}/athletes/{athleteId} - добавить спортсмена в группу
  addAthlete: async (groupId: string, athleteId: string): Promise<void> => {
    await apiClient.post(`/groups/${groupId}/athletes/${athleteId}`)
  },

  // DELETE /api/v1/groups/{id}/athletes/{athleteId} - удалить спортсмена из группы
  removeAthlete: async (groupId: string, athleteId: string): Promise<void> => {
    await apiClient.delete(`/groups/${groupId}/athletes/${athleteId}`)
  },

  // DELETE /api/v1/groups/{id} - удалить группу
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/groups/${id}`)
  },

  // PUT /api/v1/assistants/{assistantId}/groups/display-order - обновить порядок
  updateDisplayOrders: async (assistantId: string, orders: { group_id: string; display_order: number }[]): Promise<void> => {
    await apiClient.put(`/assistants/${assistantId}/groups/display-order`, {
      group_orders: orders,
    })
  },
}
